// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1hhjl","dragIcon":"SortableItem_dragIcon__1FSPT","disabled":"SortableItem_disabled__2fm5C"};